import { pbErrorMessage } from './toast.jsx';

/**
 * Turn a thrown ApiError into copy a parent can read.
 *
 * Our Go routes answer with machine-readable codes (invalid_or_expired,
 * too_many_requests, …) in the message field, so try those against the
 * `errors.*` dictionary first and only then fall back to the generic
 * status-based helper.
 */
export function errorMessage(err, t) {
  const code = err?.code;
  if (code) {
    const hit = t(`errors.${code}`);
    if (hit && hit !== `errors.${code}`) return hit;
  }
  const generic = pbErrorMessage(err, t);
  if (generic) return generic;
  return t('errors.generic');
}
